import React from 'react';
import Header from '../components/Header';

const TermsConditionsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="Terms & Conditions" showBack={true} />
      
      <div className="container mx-auto px-4 py-6">
        <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
          <div className="prose prose-sm max-w-none">
            <div className="mb-6">
              <p className="text-gray-600 text-sm mb-4">
                Last updated: {new Date().toLocaleDateString('en-IN')}
              </p>
              <p className="text-gray-700">
                Welcome to minto Mobile Repair. These Terms and Conditions ("Terms") govern your use of our doorstep mobile repair services. By using our services, you agree to these terms.
              </p>
            </div>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Service Overview</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• We provide doorstep mobile repair services at your specified location</li>
                <li>• Our technicians are trained professionals equipped with necessary tools and genuine parts</li>
                <li>• Service availability is subject to location and technician availability</li>
                <li>• We reserve the right to refuse service in certain circumstances</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">2. Booking and Payment</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• All bookings must be made through our official platform</li>
                <li>• Payment is required before service commencement</li>
                <li>• Prices are subject to change without prior notice</li>
                <li>• Additional charges may apply for complex repairs or premium parts</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">3. Technician Conduct & Company Liability</h2>
              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-4">
                <p className="text-yellow-800 font-medium text-sm">
                  ⚠️ Important Disclaimer
                </p>
              </div>
              <ul className="space-y-2 text-gray-700">
                <li>• Our technicians are independent contractors providing services on our platform</li>
                <li>• <strong>minto Mobile Repair is NOT responsible for any misconduct, unprofessional behavior, or inappropriate actions by technicians</strong></li>
                <li>• Any misbehavior, harassment, or unethical conduct by technicians is their personal responsibility</li>
                <li>• We do not assume liability for technician actions beyond the scope of repair services</li>
                <li>• Customers should report any misconduct immediately to our support team</li>
                <li>• We will take appropriate action including removal from our platform for verified misconduct</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Service Warranty</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Warranty period varies by service type (typically 30-90 days)</li>
                <li>• Warranty covers manufacturing defects in parts and workmanship</li>
                <li>• Warranty does not cover physical damage, water damage, or misuse</li>
                <li>• Warranty is void if device is tampered with by unauthorized persons</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Customer Responsibilities</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Provide accurate device information and contact details</li>
                <li>• Ensure safe and accessible location for service</li>
                <li>• Backup important data before service (we are not responsible for data loss)</li>
                <li>• Be present during service appointment</li>
                <li>• Report any issues immediately after service completion</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Limitation of Liability</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• Our liability is limited to the cost of service provided</li>
                <li>• We are not responsible for data loss, software issues, or consequential damages</li>
                <li>• We do not guarantee compatibility with all device models or software versions</li>
                <li>• Force majeure events are beyond our control and responsibility</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Privacy and Data Protection</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• We collect only necessary information for service delivery</li>
                <li>• Your personal information is protected as per our Privacy Policy</li>
                <li>• We do not access or store personal data from your device</li>
                <li>• Technicians are instructed not to access personal information</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Compliance and Reporting</h2>
              <ul className="space-y-2 text-gray-700">
                <li>• We comply with applicable local and national regulations</li>
                <li>• Report any safety concerns or misconduct to: support@mintomein.in</li>
                <li>• Emergency complaints: +91 9324 299 258</li>
                <li>• We maintain records of all service interactions for quality assurance</li>
              </ul>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Modifications</h2>
              <p className="text-gray-700">
                We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting on our platform. Continued use of our services constitutes acceptance of modified terms.
              </p>
            </section>

            <section className="mb-6">
              <h2 className="text-lg font-semibold text-gray-900 mb-3">10. Contact Information</h2>
              <div className="bg-gray-50 rounded-lg p-4">
                <p className="text-gray-700 mb-2">For questions about these Terms & Conditions:</p>
                <p className="text-gray-700">Email: support@mintomein.in</p>
                <p className="text-gray-700">Phone: +91 9324 299 258</p>
                <p className="text-gray-700">Address: Office No. 108, 1st Floor, Bama Kathod Heights, 90 Feet Road, Khambalpada Rd, near DNS Bank, Thakurli East, Dombivli, Maharashtra 421201</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditionsPage; 